import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OpenJobsSummary } from '@app/models/job.model';
import { JobService } from '@app/services/job/job.service';
import { NavigationService } from '@app/services/navigation/navigation.service';

@Component({
  selector: 'app-open-jobs',
  templateUrl: './open-jobs.component.html',
  styleUrls: ['./open-jobs.component.scss'],
  standalone: false
})
export class OpenJobsComponent implements OnInit, OnDestroy {
  readonly jobColumns = [
    { label: 'open_jobs_summary_new', type: 'New', countKey: 'new' },
    { label: 'open_jobs_summary_on_site', type: 'On-Site', countKey: 'onSite' },
    { label: 'open_jobs_summary_returning', type: 'Returning', countKey: 'returning' },
    { label: 'open_jobs_summary_awaiting_parts', type: 'Awaiting-Parts', countKey: 'awaitingParts' },
    { label: 'open_jobs_summary_ppm', type: 'PPM', countKey: 'ppm' }
  ] as const;
  summaries: OpenJobsSummary[] = [];
  siteName = '';
  brandName = '';
  hasLoaded = false;
  hasLoadError = false;

  constructor(
    private readonly jobService: JobService,
    private readonly navigationService: NavigationService,
    private readonly router: Router
  ) {
    this.navigationService.onChange(false, false);
  }

  get brands(): string[] {
    return [...new Set(this.summaries.map(summary => this.getBrandName(summary)).filter(Boolean))].sort();
  }

  get filteredSummaries(): OpenJobsSummary[] {
    const siteName = this.siteName.trim().toLowerCase();

    return this.summaries.filter(summary =>
      (!siteName || this.getSiteName(summary).toLowerCase().includes(siteName)) &&
      (!this.brandName || this.getBrandName(summary) === this.brandName)
    );
  }

  ngOnInit(): void {
    this.jobService.getOpenJobsSummary().subscribe({
      next: summaries => {
        this.summaries = summaries.map(summary => ({
          ...summary,
          awaitingParts: summary.awaitingParts ?? 0
        })).sort((left, right) =>
          this.getSiteName(left).localeCompare(this.getSiteName(right))
        );
        this.hasLoaded = true;
      },
      error: () => {
        this.hasLoadError = true;
        this.hasLoaded = true;
      }
    });
  }

  openJobList(summary: OpenJobsSummary, jobType: string, count: number): void {
    if (count > 0 && summary.site?.id) {
      void this.router.navigate(['openjobs', summary.site.id, jobType], {
        queryParams: { siteName: this.getSiteName(summary) }
      });
    }
  }

  ngOnDestroy(): void {
    this.navigationService.onChange(true, false);
  }

  getSiteName(summary: OpenJobsSummary): string {
    return summary.site?.name || '';
  }

  getBrandName(summary: OpenJobsSummary): string {
    return summary.brand?.name || '';
  }
}